import React from "react";

const Section5License = () => (
  <>
    <h2>5. License and Acceptable Use</h2>
    <p>Subject to your compliance with these Terms, Comparedly Ltd. grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license during the Subscription Term to access and use the Service solely for your internal business purposes. This license permits you to analyze social media data and generate reports using the features and functionalities provided by Comparedly.com.
    </p>
    <p>
    You agree to use the Service in accordance with these Terms and all applicable laws and regulations. You shall not, and shall not permit any third party to:
      <ul>
        <li>Access or use the Service for any illegal, unauthorized, or unethical purpose.</li>
        <li>Engage in any data scraping, data mining, or unauthorized collection of data from the Service.</li>
        <li>Infringe upon the Intellectual Property Rights of Comparedly Ltd. or any third party.</li>
        <li>Distribute, upload, or transmit any viruses, malware, or other harmful software.</li>
        <li>Disrupt, interfere with, or attempt to gain unauthorized access to the Service or any related systems or networks.</li>
        <li>Violate the terms of service of any social media platforms accessed through the Service.</li>
        <li>Use the Service in a manner that violates any acceptable use policies for social media analytics tools.</li>
        <li>Attempt to reverse engineer, decompile, or disassemble any part of the Service.</li>
        </ul>
    </p>
  
  </>
);

export default Section5License;
